import type {Conversation} from '@/client/mentor/ConversationsClient'
import {DATE_TIME_FMT, useDateTimeFormatter} from '@/composable/useDateTimeFormatter'
import {computed} from 'vue'

export function useConversationTitleFormatter() {
  const [formatDateTime] = useDateTimeFormatter(DATE_TIME_FMT)

  const Formatter = computed(() => (conversation: Conversation) => {
    return conversation.title?.trim() ?? formatDateTime.value.format(conversation.createdAt)
  })

  return [Formatter]
}
